import ThirdPartyOwnerVesselPostProcessingService from './ThirdPartyOwnerVesselPostProcessingService';

class TankersVesselPostProcessingService extends ThirdPartyOwnerVesselPostProcessingService {}

export default TankersVesselPostProcessingService;
